import {MakeStore, StoreObject} from "../../../stem-core/src/state/Store";
import {field} from "../misc/StoreField";
import {apiClient} from "../../connection/BlinkApiConnection";


export class MerchantPG extends StoreObject {
    @field("Merchant") merchant;
    @field(String) name;
    @field(Object) options; // JSON

    toString() {
        return this.name;
    }

    // TODO: Maybe have panelType as a DB field?
    getPrimaryPanelType() {
        return this.panelType ?? Object.keys(this.options ?? {})[0] ?? null;
    }

    isMocked() {
        return this.getStore() == null;
    }
}

export async function apiCreateMerchantPG(data) {
    return apiClient.post("merchant/create_pg/", data);
}

export async function apiUpdateMerchantPG(data) {
    return apiClient.post("merchant/update_pg/", data);
}

export async function apiDeleteMerchantPG(data) {
    return apiClient.post("merchant/delete_pg/", data);
}

export const MerchantPGStore = MakeStore("MerchantPG", MerchantPG);
